//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

    name: 'EventCalendar',

    scrollToTop: true,

    head() {
        return this.$head()
            .setPage(this.pageMeta)
            .get()
    },

    data() {
        return {
            modalEventId: false,
            monthsArray: false,
            events: false,
            actYear: false,
            pageMeta: {},
        }
    },

    watch: {
        '$fetchState.pending': function (newState, oldState) {
            if(newState === true) {
                this.$meta().pause()
                this.$store.commit('tracking/status', 'waiting')
            } else {
                this.$store.commit('tracking/status', 'ready')
                this.$meta().resume()
            }
        }
    },

    async fetch() {

        try {

            var response

            if(process.client) {
                response = await this.$store.cache.dispatch('media/GET_EVENTS')
            } else {
                response = await this.$store.dispatch('media/GET_EVENTS')
            }

            this.setData(response)

        } catch (e) {
            this.$logger.captureException(e)
        }

    },


    created() {
        this.$store.commit('media/category', 'events')
    },

    activated() {
        this.$store.commit('media/category', 'events')
    },

    methods: {

        eventsExists: function (month) {

            if( typeof this.events[month] === 'undefined' || this.events[month] === null || this.events[month] == '' ) {
                return false;
            }

            return true
        },

        resetData: function() {
            this.events = false
            this.monthsArray = false
            this.actYear = false
        },

        setData (data) {
            this.events = data.events
            this.monthsArray = data.monthsArray
            this.actYear = data.actYear
            this.pageMeta = data.page
        },

        detailLink (event) {
            return this.route('media.event.detail', { id: event.id, slug: this.urlSlug(event.name) })
        },

        urlSlug: function (name) {

            if(typeof name === 'undefined') {
                return name
            }

            return this.$helper.url_slug(name)

        },

        showModalEvent: function (eventId) {

            this.modalEventId = eventId

        },


    },

}

